import app from 'flarum/forum/app';
export default function on() {
  return app.forum?.attribute('gtChallengesOn') === true;
}